import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const OPERATIONAL_MODE_LABELS = {
  active: "Active",
  standby: "Standby",
  planned: "Planned",
  maintenance: "Maintenance",
  disabled: "Disabled",
  retired: "Retired",
};

export const operationalModeTone = (mode) => ({
  active: "text-emerald-400 border-emerald-700",
  standby: "text-blue-400 border-blue-700",
  planned: "text-violet-400 border-violet-700",
  maintenance: "text-amber-400 border-amber-700",
  disabled: "text-zinc-400 border-zinc-700",
  retired: "text-zinc-500 border-zinc-800",
}[mode] || "text-zinc-400 border-zinc-700");

const OperationalScopeControl = ({ value = "active", onChange, disabled = false, compact = false }) => (
  <Select value={value || "active"} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger
      data-testid="operational-mode-select"
      className={`${compact ? "h-8 w-32 text-xs" : "h-9 w-40"} bg-zinc-900 ${operationalModeTone(value)}`}
      title="Controls whether Studio expects this equipment to be online"
    >
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="bg-zinc-900 border-zinc-700">
      {Object.entries(OPERATIONAL_MODE_LABELS).map(([mode, label]) => (
        <SelectItem key={mode} value={mode}>{label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default OperationalScopeControl;

export const MonitoringProfileControl = ({ value = "full", onChange, disabled = false, compact = false }) => (
  <Select value={value || "full"} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger
      data-testid="monitoring-profile-select"
      className={`${compact ? "h-8 w-36 text-xs" : "h-9 w-44"} bg-zinc-900 border-zinc-700 text-zinc-300`}
      title="Choose how much evidence Studio collects and evaluates"
    >
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="bg-zinc-900 border-zinc-700">
      <SelectItem value="full">Full monitoring</SelectItem>
      <SelectItem value="health_only">Health only</SelectItem>
      <SelectItem value="inventory_only">Inventory only</SelectItem>
    </SelectContent>
  </Select>
);
